var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#505055",
    fillOpacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.469 13.112L12.575 9.34c-.5-.48-1.315-.48-1.815 0L9.444 8.125c1.526-1.949 1.395-4.784-.5-6.58-2.025-1.95-5.392-1.95-7.418 0C-.5 3.492-.5 6.656 1.526 8.605c1.052 1.013 2.368 1.468 3.71 1.468 1.13 0 2.235-.329 3.156-1.012l1.263 1.215c-.5.48-.5 1.266 0 1.746l3.92 3.772c.29.278.552.33.92.33.369 0 .632-.127.921-.33l1.053-1.012c.5-.405.5-1.215 0-1.671zM2.579 7.72c-1.474-1.417-1.474-3.771 0-5.189.762-.734 1.735-1.139 2.735-1.139 1 0 1.947.33 2.736 1.089 1.473 1.417 1.473 3.771 0 5.189-1.578 1.468-4.025 1.468-5.472.05zm11.943 7.138l-3.762-3.645.92-.885 3.763 3.62-.921.91z",
    transform: "translate(.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.552 4.1h2.104c.421 0 .71-.278.71-.683 0-.329-.289-.683-.71-.683H3.552c-.421 0-.71.329-.71.683 0 .405.289.684.71.684zM6.34 5.442H3.552c-.421 0-.71.279-.71.684s.289.683.71.683H6.34c.421 0 .71-.278.71-.683s-.368-.684-.71-.684z",
    transform: "translate(.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3c7881f17c8bc5e92249e09045c7c8e3.svg";
export { ForwardRef as ReactComponent };